var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBleBeacon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.134L17.7741 17.9598L18 17.7827V8.6048C18 8.52152 18.0958 8.47473 18.1615 8.52594L23.8992 13.0003C23.9504 13.0403 23.9505 13.1178 23.8994 13.1579L18 17.7827V18.134L23.8996 22.6823C23.9508 22.7217 23.9516 22.7987 23.9013 22.8393L18.1628 27.4687C18.0974 27.5214 18 27.4749 18 27.3908V18.134Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 13.2L23.8996 22.6822C23.9508 22.7217 23.9516 22.7987 23.9013 22.8393L18.1628 27.4687C18.0974 27.5214 18 27.4749 18 27.3908V8.6048C18 8.52152 18.0958 8.47473 18.1615 8.52594L23.8992 13.0003C23.9504 13.0403 23.9505 13.1178 23.8994 13.1579L11.6 22.8",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBleBeacon);
export default __webpack_public_path__ + "static/media/bleBeacon.590062f640abff6d05cde37ea07c9214.svg";
export { ForwardRef as ReactComponent };